import React from "react";
import _ from "underscore";
import { hideDialog, showDialog } from "../../../actions/dialog";
import { updatePriorities } from "../../../actions/priority";
import { setActiveMenuItem } from "../../../actions/menu";
import { Permission } from "../../../api/session";
import M from "../../../strings";
import PriorityControl from "../../components/priorityControl";
import AbstractEntitiesGrid from "./abstractEntitiesGrid";
import { alert } from "../../../plugins";
import { secureScreen } from "../../components/secure";

class CategoriesGrid extends AbstractEntitiesGrid {

    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getSubEntity()});
    }

    getInitialQuery() {
        if (this.props.level === undefined) {
            throw new Error("Please specify level");
        }

        const query = super.getInitialQuery();
        query.eq("level", this.props.level).hideFilter("level");
        query.sort("parentId", false);
        query.sort("priority", false);

        return query;
    }

    getTitle() {
        switch (this.props.level) {
            case 0: return M('macroareas');
            case 1: return M('areas');
            case 2: return M('categories');
            default: throw new Error("Unsupported category level: " + this.props.level);
        }
    }

    getSubEntity() {
        switch (this.props.level) {
            case 0: return "macroarea";
            case 1: return "area";
            case 2: return "category";
            default: throw new Error("Unsupported category level: " + this.props.level);
        }
    }

    getCreateUrl() {
        return `/entities/${this.getSubEntity()}/new`;
    }

    getEditUrl(data) {
        return `/entities/${this.getSubEntity()}/${data.id}`;
    }

    getActions() {
        const actions = super.getActions();

        actions.push({
            id: "sorting",
            type: "icon",
            icon: "zmdi zmdi-sort",
            tooltip: M("sorting"),
            permissions: [this.getEntity() + ":" + Permission.EDIT],
            action: () => { 
                const selection = _.first(this.getSelection());
                if (!_.isEmpty(selection)) {
                    showDialog({
                        title: `${M("sorting")} ${M(this.getSubEntity())} ${selection.description}`,
                        getContent: () => (<PriorityControl
                                    entity={this.getEntity()}
                                    level={this.props.level}
                                    parent={selection.parent?.id}
                                />),
                        buttons: {
                            left: [
                                {
                                    text: M("close").toUpperCase(),
                                    action: () => hideDialog(),
                                },
                            ],
                            right: [
                                {
                                    text: M("save").toUpperCase(),
                                    action: () => {
                                            updatePriorities({
                                                entity: this.getEntity(),
                                                level: this.props.level,
                                            }).finally(hideDialog);
                                        },
                                },
                            ],
                        },
                    })
                }else{                
                    alert(M("ooops"), M("selectAnElement"));
                }
            }
        });

        return actions;
    }

    getGridProps() {
        return _.extend(
                {},
                super.getGridProps(),
                {level: this.props.level}
            )
    }

}

export default secureScreen(CategoriesGrid)